/**
 * Aligns the title on PDPs with a second gallery and reveals individual
 * set component galleries only when they fall outside the viewport.
 */
(function () {
  "use strict";

  if (window.KessVariantGalleryScrollInitialized) return;
  window.KessVariantGalleryScrollInitialized = true;

  const viewportMargin = 16;

  function revealProductInfo(source, gallery) {
    if (!gallery || gallery.offsetParent === null) return;
    const title = source.closest("product-info")?.querySelector(".product__title");
    if (!title || title.offsetParent === null) return;

    const scrollDistance = title.getBoundingClientRect().top - viewportMargin;
    if (Math.abs(scrollDistance) < 1) return;

    window.scrollBy({
      top: scrollDistance,
      behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth",
    });
  }

  function revealGallery(gallery) {
    if (!gallery || gallery.offsetParent === null) return;

    const viewportHeight = window.visualViewport?.height || window.innerHeight;
    const galleryBounds = gallery.getBoundingClientRect();
    if (galleryBounds.height > viewportHeight - viewportMargin * 2) return;

    const scrollDistance = galleryBounds.bottom - viewportHeight + viewportMargin;
    if (scrollDistance <= 0 || galleryBounds.top < viewportMargin) return;

    window.scrollBy({
      top: scrollDistance,
      behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth",
    });
  }

  document.addEventListener("change", (event) => {
    const selector = event.target.closest("variant-selects");
    if (!selector) return;

    const gallery = selector
      .closest("product-info")
      ?.querySelector(".product__block--second_image_gallery .kess-shade-gallery");
    window.requestAnimationFrame(() => revealProductInfo(selector, gallery));
  });

  document.addEventListener("click", (event) => {
    const shadeButton = event.target.closest("[data-kess-duo-shade]");
    const configurator = shadeButton?.closest("[data-kess-duo-configurator]");
    if (!configurator) return;

    window.requestAnimationFrame(() => {
      revealProductInfo(configurator, configurator.querySelector("[data-kess-duo-selection]"));
    });
  });

  document.addEventListener("click", (event) => {
    const shadeButton = event.target.closest("[data-kess-set-shade]");
    const component = shadeButton?.closest("[data-kess-set-component]");
    if (!component) return;

    window.requestAnimationFrame(() => {
      revealGallery(component.querySelector("[data-kess-duo-selection]"));
    });
  });
})();
